/**
 * Provides a css variable containing the width of the window scrollbar
 *
 * TODO: Can this be replaced body { --scrollbar-width: calc(100vw - 100%); } in vanilla CSS?
 */

function getScrollbarWidth() {
  let root = document.documentElement;
  root.style.setProperty('--scrollbar', (window.innerWidth - document.body.clientWidth) + "px");
}

window.onresize = getScrollbarWidth;
getScrollbarWidth();
